export const maxDecimalValue = 999999999999999;
export const maxIntValue = 2000000000;

const formatDisplayDecimalValue = (value: string | null | undefined, separator: string = ',') => {
  if (value === null || value === undefined) return null;
  // Remove all non-numeric characters except periods
  const sanitized = value.replace(/[^0-9.]/g, '');

  // Ensure only one period for decimal point
  const parts = sanitized.split('.');
  let integerPart = parts[0] || '';
  let decimalPart = parts.length > 1 ? parts.slice(1).join('') : null;

  // round the decimal part to 2 decimal places
  if (decimalPart != null) {
    decimalPart = decimalPart.slice(0, 2);
  }

  // Preserve the cursor-friendly behavior
  integerPart = formatDisplayIntValue(integerPart, separator) ?? '';

  return decimalPart != null || decimalPart === '' ? `${integerPart}.${decimalPart}` : integerPart;
};

const formatDisplayIntValue = (value: string | null | undefined, separator: string = ',') => {
  if (value === null || value === undefined) return null;
  // Remove all non-numeric characters
  const sanitized = value.replace(/[^0-9]/g, '');

  // Preserve the cursor-friendly behavior
  const reversedInteger = sanitized.split('').reverse().join('');
  const formattedReversed = reversedInteger.replace(/(\d{3})/g, `$1${separator}`);
  // TODO(bug): the leading-separator strip is hardcoded to ',' — with any other `separator`, a number
  // whose digit count is a multiple of 3 keeps a leading separator ('123456' with '.' -> '.123.456').
  // Expected: strip a leading `separator`. Latent today: every caller uses the default ','.
  return formattedReversed.split('').reverse().join('').replace(/^,/, '');
};

const formatIntegerValue = (value: string) => {
  if (!value) return null;
  let formattedValue = formatDisplayIntValue(value);
  if (!formattedValue) return null;

  formattedValue = formattedValue.replace(/,/g, '');
  return parseInt(formattedValue);
};

const formatDecimalValue = (value: string) => {
  if (!value) return null;
  let formattedValue = formatDisplayDecimalValue(value);
  if (!formattedValue) return null;

  formattedValue = formattedValue.replace(/,/g, '');
  return parseFloat(formattedValue);
};

export const formatNumberDisplayValue = (
  value: string | null,
  questionDataType: string,
  decimalSeperator: string = ','
) => {
  if (!value) return null;

  if (questionDataType === 'decimal') {
    return formatDisplayDecimalValue(value, decimalSeperator);
  } else if (questionDataType === 'int') {
    return formatDisplayIntValue(value);
  } else {
    return value;
  }
};

export const formatNumberValue = (value: string | null, questionDataType: string) => {
  if (!value) return null;

  if (questionDataType === 'decimal') {
    return formatDecimalValue(value);
  } else if (questionDataType === 'int') {
    return formatIntegerValue(value);
  } else {
    return value ? Number(value) : null;
  }
};
